<template>
  <SidebarComponent />

  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">

        <!-- Titolo e filtri -->
        <div class="titolo-card">
          <h1>Lista Chiamate</h1>

          <!-- Bottone filtri -->
          <button @click="toggleFilters" class="filter-toggle-button">
            {{ showFilters ? "Nascondi Filtri" : "Mostra Filtri" }}
          </button>
          <FilterModule_check
            class="filter-module-fixed"
            v-show="showFilters"
            ref="filterModule"
            :userData="savedCheckData"
            @filtered-data="onFilteredData"
          />

          <!-- Select per filtrare il campo `fatto` -->
          <div class="filter-stato">
            <label for="filterFatto">Filtro Stato:</label>
            <select
              id="filterFatto"
              v-model="selectedFatto"
              @change="applyCombinedFilter"
              class="text-input"
            >
              <option value="">Tutti</option>
              <option value="da fare">da fare</option>
              <option value="si">Fatto</option>
            </select>
          </div>
        </div>

        <!-- Messaggio sola lettura -->
        <div v-if="currentUserRole === 'Studio'" class="read-only-message">
          Sei in modalità lettura. NON puoi apportare modifiche qui — contatta
          <a href="mailto:direzione@fusco.fit" class="email-link">direzione@fusco.fit</a>
        </div>

        <!-- Loader / Tabella / Nessun dato -->
        <template v-if="isLoading">
          <div class="loader">
            <h4>Caricamento in corso…</h4>
          </div>
        </template>

        <template v-else-if="filteredCheckData.length > 0">
          <div class="tickets">
            <table>
              <thead>
                <tr>
                  <th class="col-index">#</th>
                  <th class="col-azione">Azione</th>
                  <th class="col-data-creazione">Data Creazione</th>
                  <th class="col-data-consegna">Data Consegna</th>
                  
                  <th class="col-studio">Studio</th>
                  <th class="col-cognome">Cognome</th>
                                    <th class="col-note">Note generali</th>

                  <th class="col-note">Note del Check</th>
                  <th class="col-assigned-email">Email Assegnata</th>
                                    <th class="col-dafarein">Da fare in</th>
                  <th class="col-stato">Stato</th>
                  <th class="col-rowcolor">Alert</th>
<th class="col-notetrainer">Nota Problema</th>

                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="check in filteredCheckData"
                  :key="check.id"
                  :class="`bg-${check.rowColor || ''}`"
                >
                  <td class="col-index">{{ rowIndexMap[check.id] }}</td>
                  <td class="col-azione">
                    <button @click="viewUserDetails(check.uid)" class="profile-button">
                      <span class="material-icons">visibility</span>
                    </button>
                  </td>
                  <td class="col-data-creazione">
                    {{ formatDateTime(check.createdAt) }}
                  </td>
                  <td class="col-data-consegna">
                    {{ formatDate(check.dataConsegna) }}
                  </td>
                  <td class="col-studio">{{ check.studio }}</td>
                  <td class="col-cognome">{{ check.surname }}</td>
                                    <td class="col-note">{{ check.notes }}</td>

<td class="col-note">
   <input
     type="text"
     v-model="check.notedelcheck"
     @blur="updateCheckField(check.id, 'notedelcheck', check.notedelcheck)"
     class="text-input"
     placeholder="Inserisci note del check"
   />
 </td>


                                    <td class="col-assigned-email">
                    <input
                      type="text"
                      v-model="check.assignedEmail"
                      @blur="updateCheckField(check.id, 'assignedEmail', check.assignedEmail)"
                      class="text-input"
                      placeholder="(vuoto)"
                    />
                  </td>

                                    <td class="col-dafarein">
                    <select
                      v-model="check.dafarein"
                      @change="updateCheckField(check.id, 'dafarein', check.dafarein)"
                      class="text-input"
                    >
                      <option disabled value="">Seleziona</option>
                      <option value="studio">Studio</option>
                      <option value="online">Online</option>
                    </select>
                  </td>


                  <td class="col-stato">
                    <select
                      v-model="check.fatto"
                      @change="updateCheckField(check.id, 'fatto', check.fatto)"
                      class="text-input"
                    >
                      <option value="da fare">da fare</option>
                      <option value="si">fatto</option>
                    </select>
                  </td>

                  <td class="col-rowcolor">
  <select
    v-model="check.rowColor"
    @change="updateCheckField(check.id, 'rowColor', check.rowColor)"
    class="text-input"
  >
    <option disabled value="">Seleziona</option>
    <option value="red">Problema</option>
    <option value="">Risolto</option>

    <!-- aggiungi altre opzioni se serve -->
  </select>
</td>
<td class="col-notetrainer">
  <input
    type="text"
    v-model="check.noteTrainer"
    @blur="updateCheckField(check.id, 'noteTrainer', check.noteTrainer)"
    class="text-input"
    placeholder="Inserisci note"
  />
</td>



                </tr>
              </tbody>
            </table>
          </div>
        </template>

        <template v-else>
          <div>
            <p>Nessun check disponibile.</p>
          </div>
        </template>

      </div>
    </div>
  </div>
</template>



<script>
import SidebarComponent from "../SidebarComponent.vue";
import FilterModule_check from "../module/FilterModule_check.vue";
import { getAuth } from "firebase/auth";
import {
  getFirestore,
  collection,
  query,
  orderBy,
  onSnapshot,
  doc,
  getDoc,
  updateDoc
} from "firebase/firestore";

export default {
  name: "CheckComponent",
  components: { SidebarComponent, FilterModule_check },

  data() {
    return {
      savedCheckData: [],
      rawFilteredData: [],
      filteredCheckData: [],
      isLoading: true,
      showFilters: false,
      currentUserRole: "",
      rowIndexMap: {},

      selectedFilters: {
        deliveryStartDate: "",
        deliveryEndDate: ""
      },
      selectedFatto: "da fare"
    };
  },

  mounted() {
    this.initAuth();
    this.listenToRealTimeUpdates();

    const today = new Date().toISOString().split("T")[0];
    const plusThree = new Date();
    plusThree.setDate(plusThree.getDate() + 3);
    this.selectedFilters.deliveryStartDate = today;
    this.selectedFilters.deliveryEndDate = plusThree.toISOString().split("T")[0];
  },

  methods: {
    initAuth() {
      getAuth().onAuthStateChanged(async user => {
        if (!user) return;
        const db = getFirestore();
        const snap = await getDoc(doc(db, "users", user.uid));
        if (snap.exists()) this.currentUserRole = snap.data().userRole;
      });
    },

    toggleFilters() {
      this.showFilters = !this.showFilters;
      const el = this.$refs.filterModule?.$el;
      if (el) el.classList.toggle("show", this.showFilters);
    },



listenToRealTimeUpdates() {
  const db = getFirestore();
  const q = query(
    collection(db, "checkdafare"),
    orderBy("createdAt", "asc")
  );
  onSnapshot(q, snapshot => {
    const arr = snapshot.docs.map(d => {
      const dd = d.data();
      return {
        id: d.id,
        uid: dd.uid,
        surname: dd.surname,
        studio: dd.studio,
        notes: dd.notes || "",
        notedelcheck: dd.notedelcheck || "",
        assignedEmail: dd.assignedEmail || "",
        fatto: dd.fatto || "da fare",
        dafarein: dd.dafarein || "",
        noteTrainer: dd.noteTrainer || "",
        createdAt: dd.createdAt?.toDate ? dd.createdAt.toDate() : dd.createdAt,
        dataConsegna: dd.dataConsegna?.toDate ? dd.dataConsegna.toDate() : dd.dataConsegna,
        rowColor: dd.rowColor || ""
      };
    });

    // Se è il primo caricamento, oppure i dati sono cambiati molto (es. nuovo documento)
    const firstLoad = this.savedCheckData.length === 0;
    const differenze = arr.length !== this.savedCheckData.length;

    this.savedCheckData = arr;

    if (firstLoad || differenze) {
      // Aggiorna solo all'avvio o quando c'è un cambiamento evidente
      this.rawFilteredData = [...arr];
      this.applyCombinedFilter();
    }

    this.generateRowIndexMap();
    this.isLoading = false;
  });
},

    onFilteredData(data) {
      this.rawFilteredData = data;
      this.applyCombinedFilter();
    },

    applyCombinedFilter() {
      this.filteredCheckData = this.rawFilteredData.filter(
        c => !this.selectedFatto || c.fatto === this.selectedFatto
      );
      this.generateRowIndexMap();
    },

    generateRowIndexMap() {
      this.rowIndexMap = this.filteredCheckData.reduce(
        (m, c, i) => ((m[c.id] = i + 1), m),
        {}
      );
    },

    viewUserDetails(uid) {
      this.$router.push({ name: "UserDetails", params: { userId: uid } });
    },

async updateCheckField(id, field, value) {
  try {
    const db = getFirestore();
    const ref = doc(db, "checkdafare", id);
    await updateDoc(ref, { [field]: value });

    const check = this.rawFilteredData.find(c => c.id === id);
    if (check) {
      check[field] = value;
    }

    // NON ricarico tutto! Applico solo di nuovo i filtri visivi.
    this.applyCombinedFilter();
  } catch {
    alert("Errore nel salvataggio.");
  }
},


    formatDateTime(d) {
      if (!d) return "";
      const dt = new Date(d);
      return dt.toLocaleDateString("it-IT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    },

    formatDate(d) {
      if (!d) return "";
      const dt = new Date(d);
      return dt.toLocaleDateString("it-IT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      });
    }
  }
};
</script>






<style scoped>
/* Styling specifico per la select di filtro ‘Stato’ */
.filter-stato {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.filter-stato label {
  font-weight: 600;
  font-size: 16px;
}
/* Modulo filtri */
.filter-module-fixed {
  position: fixed;
  bottom: 90px;
  right: 40px;
  width: 920px;
  max-height: 90vh;
  overflow-y: auto;
  background-color: #363636 !important;
  border-radius: 30px !important;
  padding: 50px !important;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  z-index: 1000;
  transition: transform .3s, opacity .3s;
  transform: translateX(100%);
  opacity: 0;
}
.filter-module-fixed.show {
  transform: translateX(0);
  opacity: 1;
}

/* Bottone filtri */
.filter-toggle-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 100px;
  height: 100px;
  font-size: 15px;
  font-weight: bold;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  background-color: #007bff;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color .3s, transform .2s;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  z-index: 1000;
}
.filter-toggle-button:hover {
  background-color: #0056b3;
  transform: scale(1.1);
}

/* Messaggio sola lettura */
.read-only-message {
  color: #ff9800;
  font-weight: bold;
  margin-bottom: 10px;
}
.email-link {
  color: #007bff;
  text-decoration: none;
  font-weight: bold;
}
.email-link:hover {
  text-decoration: underline;
}

.tickets {
  overflow-x: auto;
  margin-bottom: 120px;
}

/* Tabella con layout fisso per rispettare le width */
table {
  width: 100%;
  min-width: 1200px;
  border-collapse: collapse;
  table-layout: fixed;
}

/* Celle generali: permettono il wrap automatico */
th, td {padding: 8px 12px;text-align: left;border-bottom: 1px solid #ddd;white-space: normal;vertical-align: top;}

/* Intestazioni */
th {background-color: #f1f1f1;font-weight: 600;}

/* Righe alternate e hover */
tbody tr:nth-child(odd)  { background-color: #ffffff; }
tbody tr:nth-child(even) { background-color: #f9f9f9; }
tbody tr:hover           { background-color: #f1f1f1; }

/* Colonne specifiche */
.col-index           { width:  40px;   }
.col-azione          { width:  50px;   }
.col-data-creazione  { width: 150px;   }
.col-data-consegna   { width: 150px;   }
.col-studio          { width: 250px;   }
.col-cognome         { width: 150px;   }
.col-note            { width: 250px; }
.col-assigned-email  { width: 300px;   }
.col-stato           { width: 120px;   }
.col-dafarein        { width: 120px;   }
.col-notetrainer     { width: 200px;   }
.col-rowcolor        { width: 120px;   }

/* Input & select dentro le celle */
.text-input { width: 100%; box-sizing: border-box; padding: 12px 6px; }

/* Pulsante visibilità */
.profile-button { background: none; border: none; cursor: pointer; }

/* Row color backgrounds */
.bg-red    { background-color: rgba(255, 0, 0, 0.2) !important; }
.bg-green  { background-color: rgba(0, 128, 0, 0.2) !important; }
.bg-yellow { background-color: rgba(255, 255, 0, 0.2) !important; }
</style>
